import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-squared-plus",
  "use": "svg_i-squared-plus-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_i-squared-plus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM4 0a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Zm9.5 9a1 1 0 0 1-1 1H10v2.5a1 1 0 1 1-2 0V10H5.5a1 1 0 1 1 0-2H8V5.5a1 1 0 1 1 2 0V8h2.5a1 1 0 0 1 1 1Z\" fill=\"#20BEE8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol